import PointLayer from "./PointLayer";

export default class EnterpriseLayer extends PointLayer {
    constructor(map, data, options = {}) {
        super(map, data, 'Enterprise', options = {scale: 0.2});
        this.mapTooltip = null;
    }

    handlerNode(node, info) {
        console.log(info);
        node.s({
            'interactive': false,
            '2d.selectable': false,
            '3d.selectable': false,
        });
        node.a({
            'ht.dataSource': info.enterprises,
            'ht.translateY': 0,
            'ht.rowHeight': 32
        });
        node.setDataBindings({
            "a": {
                "title": {
                    "id": "$yy3d_zdqy_title"
                },
                "name1": {
                    "id": "$yy3d_zdqy_name1"
                },
                "name2": {
                    "id": "$yy3d_zdqy_name2"
                },
                "name3": {
                    "id": "$yy3d_zdqy_name3"
                },
            }
        });
    }

    showLayer() {
        super.show();
    }

    hideLayer() {
        super.hide();
    }
    /**
     * 开启重点企业列表动画
     */
    startLayerAnim() {
        if(!this.enterpriseAnim) {
            const rowHeight = this.nodes[0].a('ht.rowHeight');
            const params = {
                delay: 3000,
                duration: 2000,
                easing: t => t,
                finishFunc: () => {
                    
                    this.nodes.forEach(node => {
                        let nextData = [];
                        nextData = node.a('ht.dataSource');
                        let firstElement = nextData.shift();
                        nextData.push(firstElement);
                        node.a({
                            'ht.dataSource': nextData,
                            'ht.translateY': 0
                        });
                    });

                    this.enterpriseAnim = ht.Default.startAnim(params);
                },
                action: v => {
                    this.nodes.forEach(node => {
                        node.a({
                            'ht.translateY': -rowHeight * v
                        });
                    });
                }
            };
            this.enterpriseAnim = ht.Default.startAnim(params);
        }
    }

    /**
     * 关闭重点企业列表变化的动画
     */
    stopLayerAnim() {
        if(this.enterpriseAnim) {
            this.enterpriseAnim.pause();
            this.enterpriseAnim = null;
            this.nodes.forEach(node => {
                node.a({
                    'ht.translateY': 0
                });
            });
        }
    }
}